var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "upload",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.058,
    height: 18.96,
    viewBox: "0 0 26.058 18.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_39230",
    "data-name": "Group 39230"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34170",
    "data-name": "Path 34170",
    d: "M20.361,85.61H14.77V79.961h1.848a.578.578,0,0,0,.469-.916l-3.594-4.973a.573.573,0,0,0-.932,0L8.966,79.045a.577.577,0,0,0,.469.916h1.848V85.61H5.021A5.6,5.6,0,0,1,0,80.009,5.3,5.3,0,0,1,2.63,75.43a3.556,3.556,0,0,1-.218-1.241,3.606,3.606,0,0,1,3.61-3.61,3.548,3.548,0,0,1,1.235.218,7.227,7.227,0,0,1,13.732,2.385,6.287,6.287,0,0,1-.628,12.427Z",
    transform: "translate(0 -66.65)",
    fill: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.529cbad4a05d94cf2e0eaaea228a4f61.svg";
export { ForwardRef as ReactComponent };